(() => {
  const root = document.querySelector('[data-glossary-root]');
  if (!root) return;

  const terms = [...root.querySelectorAll('[data-glossary-term]')];
  const search = root.querySelector('[data-glossary-search]');
  const count = root.querySelector('[data-glossary-count]');
  const empty = root.querySelector('[data-glossary-empty]');
  const categoryButtons = [...root.querySelectorAll('[data-glossary-category] button')];
  const indexButtons = [...root.querySelectorAll('[data-glossary-index] button')];
  let category = 'all';
  let index = 'all';

  const normalize = (value) => (value || '').normalize('NFKC').trim().toLocaleLowerCase();

  const filter = () => {
    const query = normalize(search.value);
    let visible = 0;

    terms.forEach((term) => {
      const matchesQuery = !query || normalize(term.dataset.search).includes(query);
      const matchesCategory = category === 'all' || term.dataset.category === category;
      const matchesIndex = index === 'all' || term.dataset.index === index;
      const show = matchesQuery && matchesCategory && matchesIndex;
      term.hidden = !show;
      if (show) visible += 1;
    });

    count.textContent = visible;
    empty.hidden = visible !== 0;
  };

  const bindButtons = (buttons, setValue) => {
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => item.classList.toggle('is-active', item === button));
        setValue(button.dataset.filterValue);
        filter();
      });
    });
  };

  bindButtons(categoryButtons, (value) => { category = value; });
  bindButtons(indexButtons, (value) => { index = value; });
  search.addEventListener('input', filter);
})();
